import * as libLocation from "../lib/location.ts";
import * as Html from "../util/Html.ts";
import * as modal from "../util/modal.ts";
import ApiServer from "../ApiServer.js";
import * as Storage from "../lib/Storage.ts";
import * as FwDatas from "../FwDatas.ts";
import * as forms from "../util/forms.js";
import * as i18n from "../i18n.ts";

Html.register({
  emailvalidate:function(email){
    import("../modal/email_validate.mustache").then(function(tpl){
      modal.closeModal();
      modal.openModal(tpl,{email:email});
    });
  },
  emailvalidateok:function(email){
    ApiServer.accsendaccountidentifiervalidationcode(null,null,email,null,"TOKEN",function(){
      import("../modal/email_validate_sent.mustache").then(function(tpl){
        modal.closeModal();
        modal.closeSnack();
        Storage.sessionSet('emailvalidatedchecked',true);
          
        modal.openModal(tpl,{email:email}).onClose = (function(){
          libLocation.refresh()
        });
      });  
    })
    
  },
  emailvalidatechange:function(email){
    import("../modal/email_validate_change.mustache").then(function(tpl){
      modal.closeModal();
      modal.openModal(tpl,{oldEmail:email});
    });
  },
  emailvalidatechangewithemail:function(oldEmail){
    var email = this.parent().find('input').val()
    import("../modal/email_validate_askpass.mustache").then(function(tpl){
      modal.closeModal();
      modal.openModal(tpl,{email:email,oldEmail:oldEmail});
    });
  }
});


ApiServer['custom.changeidentifier'] = ApiServer.accchangeaccountidentifier.prepare({validationmethod:"TOKEN"},function(identifier){
  import("../modal/email_validate_sent.mustache").then(function(tpl){
    modal.closeModal();
    modal.openModal(tpl,{email:identifier.value,changed:true}).onClose = (function(){libLocation.refresh()});
  });  
},function(err){
  if(err.code==="3"){
    forms.markInvalid($('form[data-fw-dyn-action="custom.changeidentifier"] input[type="password"]'),i18n.get("fw2.apierrors.3"))
  }else{
    throw err;
  }
})

function checkEmailverified() {
  if (!Storage.sessionGet('emailvalidatedchecked')) {
    let email = getMainEmailIdentifier()
    if (email && !email.validated) {
      import("../modal/email_validatesnackbar.mustache").then(function(TPL) {
        modal.snack(TPL, { email: email.value }).onClose = function() {
          Storage.sessionSet('emailvalidatedchecked', true)
        }
      });
    }
  }  
}
function getMainEmailIdentifier(){
  let
    emails = FwDatas.getUser().identifiers.filter(identifier => identifier.type === 'Email'),
    validated = emails.filter(identifier => identifier.validated),
    notValidated = emails.filter(identifier => !identifier.validated);
  
  if(validated.length>0){
    return validated[0];
  }
  if(notValidated.length>0){
    return notValidated[0];
  }
  return null;
    
}
export {checkEmailverified,getMainEmailIdentifier}